import { UserData } from '@/types/user';
import Base from './Base';
import { ApiResponse } from '@/types/api';

class User extends Base {
  async show() {
    const response = await this.apiClient.get<ApiResponse<UserData>>(`/users`);

    return response.data;
  }
}

export default User;
